import { TextField, InputAdornment, CircularProgress } from '@mui/material';
import { baseTheme, IconButton } from 'design-system';
import { useMemo } from 'react';
import { MdClose, MdSearch } from 'react-icons/md';

// TODO: Investigate if another similar component exists. See SearchBar
const SearchInputField = ({
  inputValue,
  isDisabled = false,
  isFetching = false,
  onInputChange,
  onClick,
  onClear,
  inputRef,
}: {
  inputValue: string;
  isDisabled?: boolean;
  isFetching?: boolean;
  onInputChange?: React.ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement> | undefined;
  onClick: () => void;
  onClear?: () => void;
  inputRef?: React.Ref<HTMLInputElement>;
}) => {
  const handleInputInteraction = (event: React.SyntheticEvent) => {
    event.stopPropagation();
    onClick();
  };

  const hasValue = inputValue.length > 0;
  const startAdornment = useMemo(
    () => (
      <InputAdornment position="start">
        {isFetching ? (
          <CircularProgress size={16} color="inherit" aria-label="Searching" />
        ) : (
          <MdSearch style={{ color: hasValue ? baseTheme.palette.success.main : undefined }} />
        )}
      </InputAdornment>
    ),
    [isFetching, hasValue],
  );

  const endAdornment = useMemo(
    () =>
      onClear &&
      hasValue && (
        <InputAdornment position="end">
          <IconButton aria-label="Clear search" edge="end" onClick={onClear} sx={{ width: 28, height: 28, p: 0.5 }}>
            <MdClose />
          </IconButton>
        </InputAdornment>
      ),
    [onClear, hasValue],
  );

  const slotProps = useMemo(() => ({ input: { startAdornment, endAdornment } }), [startAdornment, endAdornment]);

  return (
    <TextField
      label=""
      aria-label="Search"
      variant="outlined"
      fullWidth
      autoComplete="off"
      inputRef={inputRef}
      disabled={isDisabled}
      sx={(theme) => ({
        background: 'transparent',
        '& > div:first-of-type': {
          background: theme.palette.common.white,
        },
        '& input': {
          '&::placeholder': {
            fontWeight: theme.typography.fontWeightRegular,
            color: theme.palette.common.black,
          },
        },
      })}
      slotProps={slotProps}
      value={inputValue}
      onChange={onInputChange}
      onMouseDown={handleInputInteraction}
      onTouchStart={handleInputInteraction}
    />
  );
};

export default SearchInputField;
